import cacheLs from "../cacheLs"

export default {
  addTPrepSubjectModule (state, data) {
    state.selectedTPrepSubjectModule = { ...data }
    cacheLs.set_subject_module(data)
  }
}
